// eslint-disable-next-line no-undef
const isTestSSP = process.env.MIX_TEST_SSP === 'true';
const webId = process.env.MIX_WEB_ID;

const BASE_URL = '/api/adds';
const BRANDING = 'branding';
const MOBILE_SCREEN_BREAKPOINT = 768;
const MAX_FILE_SIZE = 500 * 1024; // 300 kB
const MOBILE = 'mobile';
const DESKTOP = 'desktop';

export default () => ({
  adds: [],
  sssp: null,
  webContainer: null,
  mobileBranding: document.getElementById('mobile-branding'),

  get isMobile() {
    return window.innerWidth < MOBILE_SCREEN_BREAKPOINT;
  },

  init() {
    this.webContainer = document.getElementById('web-container');
    this.handleAdPreview(); // Handle preview mode

    const urlParams = new URLSearchParams(window.location.search);

    this.initSsp();
  },

  initSsp() {
    const sspScript = document.getElementById('ssp-script');
    sspScript.addEventListener('load', this.handleSspLoad.bind(this));
  },

  async removeBranding() {
    this.webContainer.classList.remove('has-branding');

    // Select all elements with data-add="branding"
    const brandingDivsToRemove = document.querySelectorAll(`div[data-add="branding"]`);

    // Create a promise for each element to be removed
    await Promise.all(Array.from(brandingDivsToRemove).map(div => {
      return new Promise((resolve) => {
        div.remove();
        resolve();
      });
    }));
  },

  handleSeznamAddTags() {
    return new Promise((resolve) => {
      const placementToRemove = this.isMobile ? 'desktop' : 'mobile';

      // Select and remove all divs with the specific placement
      const divsToRemove = document.querySelectorAll(`div[data-placement="${placementToRemove}"]`);
      divsToRemove.forEach(div => div.remove());

      resolve();
    });
  },


  handleCustomAddTags() {
    // First group the adds by type
    const addsByType = this.adds.reduce((acc, add) => {
      if (!acc[add.type]) {
        acc[add.type] = [];
      }
      acc[add.type].push(add);
      return acc;
    }, {});

    // Shuffle function to randomize the ads
    function shuffle(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    }

    // Now, go through each type and distribute the ads
    Object.keys(addsByType).forEach((addType) => {
      let addInstances = shuffle(addsByType[addType]); // Shuffle ads of this type

      // Get elements that match both data-add and the correct placement (mobile or desktop)
      const placement = this.isMobile ? 'mobile' : 'desktop'; // Determine placement based on screen size
      const elements = document.querySelectorAll(`[data-add="${addType}"][data-placement="${placement}"]`);

      // Shuffle the elements as well
      const shuffledElements = shuffle(Array.from(elements));

      // Distribute ads into the available elements
      shuffledElements.forEach((element) => {
        if (addInstances.length > 0) {
          const add = addInstances.shift(); // Get the first ad in the shuffled list
          this.renderAd(element, add); // Render the ad in the current element
        }
      });
    });
  },

  renderAd(element, add) {
    // Skip elements that have the "adds--preview" class (preview mode)
    if (element.classList.contains('adds--preview')) {
      return;
    }

    const isBranding = add.type === BRANDING;

    // Choose the image based on the screen width
    const imageUrl = this.isMobile && add.banner.mobile ? add.banner.mobile : add.banner.desktop;
    const banner = document.createElement('a');
    banner.href = add.target;
    banner.target = '_blank'; // Open in new tab/window

    if (isBranding && this.isMobile) {
      element.classList.add('adds--branding-mobile');
    }

    const image = document.createElement('img');

    image.src = imageUrl;
    image.alt = `${add.type} banner`;
    banner.appendChild(image);
    element.appendChild(banner); // Append the banner link to the element

    // Remove the data-szn-ssp-ad attribute
    element.removeAttribute('data-szn-ssp-ad');
  },

  removeEmptyElements() {
    document.querySelectorAll('[data-add]').forEach((element) => {
      setTimeout(() => {
        if (!element.hasChildNodes() || !element.innerHTML.trim()) {
          const parent = element.closest('.adds__popup-mobile-wrapper');
          if (parent) {
            parent.remove();
          } else {
            element.remove();
          }
        }
      }, 300);
    });
  },

  checkForBranding() {
    const hasBranding = this.adds.some((add) => add.type === BRANDING);
    if (!hasBranding) {
      this.removeBranding();
    }
  },

  injectStickyAd() {
    if (this.isMobile && !this.sssp.displaySeznamAds()) {
      const hasPopupMobile = this.adds.some((add) => add.type === 'popup_mobile');
      if (!hasPopupMobile) {
        const stickyScript = document.createElement('script');
        stickyScript.src = 'https://rtb.admaster.cz/js/adm-nastartu.js';
        stickyScript.async = true;
        document.body.appendChild(stickyScript);

        const stickyDiv = document.createElement('div');
        stickyDiv.id = 'adm-sticky';
        stickyDiv.classList.add('adds--mobile-sticky');
        document.body.appendChild(stickyDiv);
      }
    }
  },

  injectOutstreamAd() {
    if (this.sssp.displaySeznamAds()) return;

    const article = document.querySelector('.article__content');

    if (!article) return;

    // Najdi odstavec (p) 2 nebo 3
    const paragraphs = article.querySelectorAll('p');

    let insertAfter = paragraphs[1] || paragraphs[0]; // mezi 1. a 2. odstavcem

    if (!insertAfter) return;

    const outstreamWrapper = document.createElement('div');
    outstreamWrapper.classList.add('adds--outstream');

    // Vlož wrapper hned po zvoleném odstavci
    insertAfter.parentNode.insertBefore(outstreamWrapper, insertAfter.nextSibling);

    // Vlož outstream script
    const inlineScript = document.createElement('script');
    inlineScript.setAttribute('data-playerPro', 'current');
    inlineScript.textContent = `(function(){var s=document.querySelector('script[data-playerPro="current"]');s.removeAttribute("data-playerPro");(playerPro=window.playerPro||[]).push({id:"is83ejY5i0b6",after:s});})();`;

    outstreamWrapper.appendChild(inlineScript);
  },

  async fetchCustomAdds() {
    this.loading = true;
    try {
      // Získání slugu z cesty URL
      const path = window.location.pathname;
      const slug = path.split('/').filter(Boolean).pop() || null;

      // Přidání slugu jako GET parametru
      const url = slug ? `${BASE_URL}?slug=${slug}`: BASE_URL;

      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      this.adds = data.data;
    } catch (error) {
      console.error('There was a problem fetching the adds:', error);
    } finally {
      this.loading = false;
      this.handleCustomAddTags();
      this.checkForBranding();
    }
  },

  async handleSspLoad() {
    this.sssp = window.sssp; // Bind window.sssp to this.sssp
    this.sssp.config({ webId: webId, test: isTestSSP });
    if (this.sssp.displaySeznamAds()) {
      await this.removeBranding();
    } else {
      await this.fetchCustomAdds();
      this.injectStickyAd();
      this.injectOutstreamAd();

    }
    await this.handleSeznamAddTags();
    this.sssp.getAdsByTags();
    // Remove empty elements after a delay
    setTimeout(() => {
      this.removeEmptyElements();
    }, 300); // 300ms delay
  },

  handleAdPreview() {
    const previewAddType = this.getPreviewAddType();

    if (previewAddType) {
      const addElement = this.getAddElement(previewAddType);
      if (addElement) {
        this.setupPreviewElement(addElement);

        setTimeout(() => {
          addElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500); // Delay for the image to load
        // Scroll to the banner element
      }
    }
  },

  getPreviewAddType() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('adds-preview');
  },

  getAddElement(previewAddType) {
    // Check if the ad type is 'branding'
    if (previewAddType === BRANDING) {
      // Use 'data-placement' to differentiate between mobile and desktop
      const placement = this.isMobile ? MOBILE : DESKTOP;
      return document.querySelector(`[data-add="branding"][data-placement="${placement}"]`);
    }

    // Default behavior for non-branding ads
    return document.querySelector(`[data-add="${previewAddType}"]`);
  },


  setupPreviewElement(addElement) {
    const dimension = addElement.getAttribute('data-dimension');

    this.applyPreviewStyles(addElement, dimension);
    this.removeAdAttributes(addElement);
    this.createPreviewContent(addElement, dimension);
  },

  applyPreviewStyles(addElement, dimension) {
    addElement.classList.add('adds--preview');
    const [width, height] = dimension.split('x');
    addElement.style.width = `${width}px`;
    addElement.style.height = `${height}px`;
  },

  removeAdAttributes(addElement) {
    addElement.removeAttribute('data-szn-ssp-ad');
    addElement.removeAttribute('id');
  },

  createFileInput() {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/jpeg';
    fileInput.style.display = 'block';
    return fileInput;
  },

  createPreviewContent(addElement, dimension) {
    const previewDiv = document.createElement('div');
    previewDiv.innerHTML = `<p class="info-text">Rozměry: ${dimension}</p><p class="info-text">Maximální velikost: ${(MAX_FILE_SIZE / 1024 / 1024).toFixed(1)} MB</p>`;

    const fileUploadWrapper = document.createElement('div');
    fileUploadWrapper.classList.add('file-upload');

    const fileInputLabel = document.createElement('label');
    fileInputLabel.classList.add('file-upload-label');
    fileInputLabel.textContent = 'Vybrat soubor';

    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/jpeg';
    fileInput.classList.add('file-upload-input');

    const changeBannerBtn = document.createElement('button');
    changeBannerBtn.textContent = 'Změnit banner';
    changeBannerBtn.classList.add('change-banner-btn');

    fileUploadWrapper.appendChild(fileInputLabel);
    fileUploadWrapper.appendChild(fileInput);
    previewDiv.appendChild(fileUploadWrapper);
    previewDiv.appendChild(changeBannerBtn);

    addElement.innerHTML = ''; // Clear the existing content
    addElement.appendChild(previewDiv);

    this.handleFileUpload(fileInput, previewDiv, changeBannerBtn, previewDiv, addElement);
  },

  handleFileUpload(fileInput, previewDiv, changeBannerBtn, previewContainer, addElement) {
    // Listen for changes to the file input
    fileInput.addEventListener('change', () => {
      const file = fileInput.files[0];

      // Check file before uploading
      if (file && file.size <= MAX_FILE_SIZE && file.type === 'image/jpeg') {
        const reader = new FileReader();
        reader.onload = (e) => {
          // Remove any previous images if they exist
          previewContainer.querySelectorAll('img').forEach(img => img.remove());

          // Add the new image
          const image = new Image();
          image.src = e.target.result;

          // If branding, set image size based on dimensions
          if (addElement.classList.contains('adds--branding')) {
            const dimension = addElement.getAttribute('data-dimension');
            if (dimension) {
              const [width, height] = dimension.split('x');
              image.style.width = `${width}px`;
              image.style.height = `${height}px`;
            }
          } else {
            image.style.maxWidth = '100%';
          }

          previewDiv.appendChild(image);

          // Add class to the parent div (addElement) that holds data attributes
          addElement.classList.add('adds--preview-set');
        };
        reader.readAsDataURL(file);
      } else if (file) {
        // If file doesn't meet conditions, show an alert in Czech and reset the input
        alert('Soubor musí být ve formátu JPG a menší než ' + (MAX_FILE_SIZE / 1024 / 1024).toFixed(1) + ' MB');
        fileInput.value = ''; // Reset the file input
      }
    });

    // Event for the "Change banner" button
    changeBannerBtn.addEventListener('click', () => {
      // Remove the displayed image
      previewContainer.querySelectorAll('img').forEach(img => img.remove());

      // Remove class from the parent div (addElement) that holds data attributes
      addElement.classList.remove('adds--preview-set');
    });
  }
});
